import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

import "./McaCourse.css";
import {
  FaClock,
  FaLaptop,
  FaUserCheck,
  FaBookOpen,
  FaHandsHelping,
} from "react-icons/fa";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Form,
} from "react-bootstrap";
import { FaUniversity, FaGraduationCap, FaBook } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import { FaChartLine, FaHandshake, FaUsers } from "react-icons/fa";
import Slider from "react-slick";
import { FaPlus, FaMinus } from "react-icons/fa"; // ✅ using react-icons
import {
  FaSnowflake,
  FaUser,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
} from "react-icons/fa";
import Admission from "../../components/Admission";
import Partner from "../../components/Partner";

export default function MaCourse() {
  const careers = [
    {
      icon: "💻",
      title: "Teacher/Lecturer",
    },
    {
      icon: "🌐",
      title: "Content Writer",
    },
    {
      icon: "📊",
      title: "Civil Services",
    },
    {
      icon: "🖥️",
      title: "Research Analyst",
    },
    {
      icon: "🗄️",
      title: "NGO",
    },
    {
      icon: "☁️",
      title: "Public Relations Officer",
    },
    {
      icon: "🔐",
      title: "Journalist",
    },
    {
      icon: "📂",
      title: "Higher Education (PhD/M.Phil)",
    },
  ];

  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const highlights = [
    {
      icon: "⏰",
      title: "Course Duration",
      description:
        "2 years (4 semesters) — designed for efficient learning while balancing work or other commitments.",
    },
    {
      icon: "📚",
      title: "Learning Mode",
      description:
        "Distance / Online — study from anywhere with access to online classes, study material, and recorded lectures.",
    },
    {
      icon: "🔍",
      title: "Eligibility",
      description:
        "A bachelor's degree (preferably BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation.",
    },
    {
      icon: "🏛️",
      title: "University Recognition",
      description:
        "Courses offered are from UGC and AICTE-approved universities, ensuring your degree is valid and recognized.",
    },
    {
      icon: "📖",
      title: "Curriculum",
      description:
        "Covers core programming, software engineering, DBMS, networking, cloud computing, and more.",
    },
    {
      icon: "🎧",
      title: "Support & Flexibility",
      description:
        "Study on your schedule with weekend sessions, recorded classes, student support, and online doubt-solving.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const data = [
    { icon: <FaChartLine />, number: "100%", label: "Success Rate" },
    { icon: <FaHandshake />, number: "35+", label: "Years Of Service" },
    { icon: <FaUsers />, number: "8k+", label: "Students" },
    { icon: <FaBook />, number: "10+", label: "Courses" },
  ];

  const plans = [
    {
      id: "01",
      color: "#00c6ff",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "02",
      color: "#2ecc71",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "03",
      color: "#f1c40f",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "04",
      color: "#e67e22",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "05",
      color: "#9b59b6",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "06",
      color: "#2980b9",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
  ];

  const blogs = [
    {
      title: "Writing Class",
      image: "https://via.placeholder.com/400x250?text=Writing+Class",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Crafts Activities",
      image: "https://via.placeholder.com/400x250?text=Crafts+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Math Activities",
      image: "https://via.placeholder.com/400x250?text=Math+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
  ];

  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Establishing goals & blueprints for the new website",
      icon: "🔍",
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Defining information architecture & content plan",
      icon: "📝",
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Designing the form & function of the website",
      icon: "🎨",
    },
  ];

  const faqData = [
    {
      question: "What is a Distance MA program?",
      answer:
        "A Distance MA is a postgraduate arts degree offered online or through correspondence, allowing students to specialize in subjects like English, History, Political Science, Economics, and more without attending regular campus classes.",
    },
    {
      question: "Is a Distance MA recognized and valid for jobs?",
      answer:
        "Yes. A Distance MA from a UGC-approved university is fully valid for private and government jobs as well as for pursuing MPhil or PhD programs.",
    },
    {
      question: "What are the eligibility criteria for MA distance education?",
      answer:
        "Applicants generally need a bachelor’s degree in any discipline from a recognized university. Some universities may require a relevant subject background depending on the specialization.",
    },
    {
      question: "How long does it take to complete a Distance MA?",
      answer:
        "Most Distance MA programs are designed to be completed in 2 years, though some universities allow students to extend the duration if needed.",
    },
    {
      question: "Can I work while pursuing a Distance MA?",
      answer:
        "Yes. Distance MA courses are ideal for working professionals and students who need flexibility, enabling you to study and submit assignments according to your own schedule.",
    },
    {
      question: "What career opportunities are available after a Distance MA?",
      answer:
        "Graduates can pursue careers in teaching, research, public administration, journalism, content writing, social services, or continue higher studies like MPhil and PhD.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const features = [
    {
      icon: <FaSnowflake />,
      title: "Study While You Work",
      details:
        "Pursue your MA distance education in Bangalore without leaving your job. Flexible schedules allow learners to balance work, studies, and career growth efficiently.",
    },
    {
      icon: <FaUser />,
      title: "Access Anytime, Anywhere",
      details:
        "With online MA courses in Bangalore, access study materials, recorded lectures, and assignments 24/7 from any location, ensuring convenient and uninterrupted learning.",
    },
    {
      icon: <FaDollarSign />,
      title: "Lower Cost, Same Degree",
      details:
        " Distance MA programs are affordable. Degrees from best MA distance learning colleges in Bangalore are fully recognized and offer the same value as regular programs.",
    },
    {
      icon: <FaBuilding />,
      title: "UGC/AICTE Approved Programs",
      details:
        " Earn a credible qualification from UGC-approved MA distance education universities, ensuring recognition for teaching, research, civil service opportunities, and professional advancement.",
    },
    {
      icon: <FaTruck />,
      title: "Career-Aligned Curriculum",
      details:
        " The curriculum is designed for practical knowledge and skills development, preparing students from distance MA colleges in Bangalore for academic, research, and professional careers.",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Self-Paced Learning with Expert Support",
      details:
        "Study independently with guidance from qualified faculty through MA correspondence courses in Bangalore, receiving mentorship, doubt-solving sessions, and academic support as needed.",
    },
  ];

  const highlightsData = [
    {
      icon: <FaClock size={36} className="text-primary mb-3" />,
      title: "Course Duration",
      description:
        " The MA distance education in Bangalore program typically spans 2 years (4 semesters), providing enough time to gain expertise while balancing work, studies, or other professional commitments.",
    },
    {
      icon: <FaLaptop size={36} className="text-success mb-3" />,
      title: "Learning Mode",
      description:
        "Offered in regular and flexible online MA courses in Bangalore, including digital lectures, study materials, and virtual classes, enabling students to learn conveniently from anywhere.",
    },
    {
      icon: <FaUserCheck size={36} className="text-warning mb-3" />,
      title: "Eligibility",
      description:
        "Graduation in any stream from a recognized university is required to enroll in distance MA colleges in Bangalore, ensuring a smooth academic transition into postgraduate studies.",
    },
    {
      icon: <FaUniversity size={36} className="text-info mb-3" />,
      title: "University Recognition",
      description:
        "Programs are from UGC-approved MA distance education institutions, guaranteeing credibility, professional recognition, and eligibility for academic advancement or government and corporate opportunities.",
    },
    {
      icon: <FaBookOpen size={36} className="text-danger mb-3" />,
      title: "Curriculum",
      description:
        "Covers in-depth theoretical knowledge and practical insights in your chosen specialization, designed by top faculty from best MA distance learning colleges in Bangalore.",
    },
    {
      icon: <FaHandsHelping size={36} className="text-secondary mb-3" />,
      title: "Support & Flexibility",
      description:
        " Students receive academic guidance, access to online resources, and flexible schedules, making MA correspondence courses in Bangalore ideal for working professionals and self-paced learners.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Best Online MA Colleges | UGC Approved MA Distance Education
        </title>
        <meta
          name="description"
          content="UGC-approved MA distance education in Bangalore. Join the best online MA colleges offering flexible MA correspondence courses and distance learning programs."
        />
      </Helmet>
      <div className="mca-course-page">
        {/* ===== MCA Course Header ===== */}
        <section className="mca-course-header py-5 text-white">
          <Container>
            <Row className="align-items-center">
              {/* MCA Course Info */}
              <Col md={7} className="mca-course-header-content">
                <span className="mca-course-badge badge bg-warning text-dark mb-3">
                  Live Classes
                </span>
                <h1 className="mca-course-title fw-bold mb-3">
                  Master of Arts (MA){" "}
                </h1>
                <p className="mca-course-subtitle lead mb-3">
                  This MCA program is designed to build a strong foundation in
                  computer applications, programming, software development, and
                  IT management. You’ll gain advanced skills required for
                  careers in the tech industry.
                </p>
                <Button
                  variant="warning"
                  size="lg"
                  className="mca-course-enroll-btn fw-bold"
                >
                  Get admitted to the batch
                </Button>

                {/* MCA Course Rating */}
                <div className="mca-course-rating mt-3 d-flex align-items-center">
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <span className="ms-2">(4.8)</span>
                </div>
              </Col>

              {/* MCA Course Thumbnail */}
              <Col md={5} className="mca-course-header-thumbnail text-center">
                <img
                  src="/images/954068-removebg-preview.png"
                  alt="MCA Course Preview"
                  style={{ height: "400px", marginTop: "100px" }}
                />
              </Col>
            </Row>
          </Container>
        </section>

        {/* ===== MCA Course Content Section ===== */}

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              MA Distance Education – Advance Your Knowledge in Humanities &
              Social Sciences{" "}
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              The Master of Arts (MA) distance education program is designed to
              provide advanced knowledge in humanities, social sciences, and
              related fields. Typically spanning two years, students can
              specialize in disciplines such as English, History, Political
              Science, Sociology, Economics, Psychology, and more. This program
              enhances critical thinking, research skills, and theoretical
              understanding, making it ideal for academic, research, teaching,
              civil services, content writing, or counseling careers. Through MA
              distance education in Bangalore, learners can earn a degree from
              UGC-approved MA distance education universities while balancing
              work or other commitments. Flexible online MA courses in Bangalore
              and MA correspondence courses in Bangalore ensure access to study
              materials, recorded lectures, and virtual classrooms without
              attending regular classes. Programs offered by distance MA
              colleges in Bangalore and best MA distance learning colleges in
              Bangalore provide recognized degrees from UGC-approved MA online
              institutions, ensuring credibility and career opportunities
              nationwide.
            </p>
          </Container>
        </section>

        <section
          style={{ background: "linear-gradient(to right, #f9fafb, #eef2ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Key Highlights of the MA Distance Education Program
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                Making quality education accessible, flexible, and
                career-focused for learners across India.
              </p>
            </div>

            {/* Highlights Grid */}
            <Row className="g-4">
              {highlightsData.map((highlight, index) => (
                <Col md={6} key={index}>
                  <Card className="h-100 shadow border-0 text-center">
                    <Card.Body>
                      {highlight.icon}
                      <h5 className="fw-bold">{highlight.title}</h5>
                      <p className="text-muted">{highlight.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              MA Distance Education – Advance Your Career in Arts & Humanities
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              Pursuing an MA distance education is an excellent way to deepen
              your expertise in arts, humanities, and social sciences while
              studying at your own pace. This program is ideal for graduates who
              wish to enhance their academic profile, develop research skills,
              or prepare for careers in teaching, public administration,
              writing, or social work. The MA distance education in Bangalore
              program offers specializations such as English, History,
              Sociology, Political Science, Economics, and more. The curriculum
              emphasizes theory, critical thinking, and independent research,
              ensuring students gain practical insights and academic credibility
              equivalent to regular classroom programs. Distance MA colleges in
              Bangalore and best MA distance learning colleges in Bangalore
              provide programs from UGC-approved MA distance education
              universities. Students benefit from flexible schedules, online
              study materials, recorded lectures, and academic guidance. MA
              correspondence courses in Bangalore allow learners to pursue
              higher education without compromising professional or personal
              commitments.
            </p>
          </Container>
        </section>

        <section className="why-section">
          <div className="why-head">
            <h1>Why Choose MA via Distance Education?</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img
                src="/images/whychoose.jpg"
                alt="Why Choose Bangalore Distance Education for Your MA Distance Education"
              />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                Distance MA programs are increasingly popular among students and
                working professionals seeking to advance their careers without
                affecting current commitments. Choosing MA distance education in
                Bangalore offers flexibility, recognized degrees, and
                career-focused learning opportunities.
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Admission Process */}

        <Admission></Admission>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h1 className="text-center mb-5">Career Opportunities After MCA</h1>
            <p
              className="text-center mb-5"
              style={{ color: "#666", fontSize: "16px" }}
            >
              Earning an MCA through distance education opens up diverse career
              opportunities in the growing tech industry. With advanced
              knowledge in programming, software systems, and IT management, MCA
              graduates are highly sought after in both private and public
              sectors.
            </p>

            {/* Career Grid */}
            <Row className="text-center">
              {careers.map((career, index) => (
                <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                  <div style={{ fontSize: "48px" }}>{career.icon}</div>
                  <h6 className="fw-bold mt-3">{career.title}</h6>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Partner></Partner>

        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={10} lg={8}>
              <h1 className="fw-bold display-6 mb-3">
                Take the Next Step with Our Distance MA Program
              </h1>
              <p className="text-muted fs-5">
                Ready to elevate your academic and professional journey? Our MA
                distance education in Bangalore program is designed for
                graduates who want to specialize in arts and humanities while
                studying flexibly from anywhere. Whether you are aiming for a
                career in education, public administration, research, or content
                development, online MA courses in Bangalore help you develop
                strong analytical, communication, and research skills essential
                for success. With specializations such as English, History,
                Political Science, Sociology, and more, the curriculum combines
                theoretical depth with practical relevance. Offered by best MA
                distance learning colleges in Bangalore, this UGC-approved MA
                distance education program is affordable and tailored for
                working professionals or students seeking a flexible learning
                path.
              </p>
            </Col>
          </Row>
        </Container>

        {/* Register Now */}

        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>Take the Next Step with Our Distance MA Program</h3>
            <p>
              Ready to elevate your academic and professional journey? Our
              Distance MA program is designed for graduates who wish to
              specialize in arts and humanities while enjoying the flexibility
              to study from anywhere. Whether you’re aiming for a career in
              education, public administration, research, or content
              development, this program helps you build strong analytical and
              communication skills essential for success. With a wide range of
              specializations such as English, History, Political Science,
              Sociology, and more, the curriculum is thoughtfully designed to
              combine theoretical depth with real-world relevance. The program
              is UGC-recognized, affordable, and tailored for working
              professionals or students who need a flexible learning path.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form>
          </div>
        </div>

        {/* FAQ */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-5">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>

            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
